module.exports = __webpack_public_path__ + "img/product_logo.09716c95.png";